module.exports = __webpack_public_path__ + "img/content_4_NutrientAccumulation.205bf69e.png";